import {
  ENTER_KEY,
  TAB_KEY,
  ZERO_KEY,
  NINE_KEY,
  BACKSPACE_KEY,
  LEFT_KEY,
  RIGHT_KEY,
  DELETE_KEY
} from "../shared_critical/constants/keys";

MOVE.MORTGAGE = (function (MOVE) {
  var query_vars = null;
  var getQueryValue = function (query_key) {

    if (query_vars === null) {
      query_vars = getUrlVars();
    }

    var query_value = '';
    if (query_vars !== null) {
      if (query_vars[query_key] !== null) {
        query_value = query_vars[query_key];
      }
    }

    return query_value;
  };

  var getDevicePrefix = function(MOVE_DATA) {
    if (MOVE_DATA.isDesktop) {
      return 'web_';
    } else if (MOVE_DATA.isTablet) {
      return 'tabletw_';
    } else if (MOVE_DATA.isPhone) {
      return 'mobilew_';
    } else {
      return false;
    }
  }

  var getUrlVars = function () {
    var location = window.location;
    var queryParams = location.search
      .slice(1)
      .replace(/[#?]/g, '&')
      .split('&')
      .map(function(p) {
        return p.split('=');
      })
      .reduce(function(obj, pair) {
        if (pair.length !== 2) return obj;
        try {
          const [key, value] = pair.map(decodeURIComponent);
          obj[key] = value.replace(/\//g, '');
        } catch(e) {
          return obj;
        }
        return obj;
      }, {});

    var hashParams = location.hash
      .slice(1)
      .replace(/[#?]/g, '&')
      .split('&')
      .map(function(p) {
        return p.split('=');
      })
      .reduce(function(obj, pair) {
        if (pair.length !== 2) return obj;
        try {
          const [key, value] = pair.map(decodeURIComponent);
          obj[key] = value.replace(/\//g, '');
        } catch(e) {
          return obj;
        }
        return obj;
      }, {});

    var vars = $.extend({}, queryParams, hashParams);
    return vars;
  };

  var validateRange = function (val, min, max) {

    if (val === null || val === undefined || isNaN(val) || val < min) {
      val = min;
    } else if (val > max) {
      val = max;
    }

    return val;
  };

  var rateFormatter = function (rate) {
    return rate.toFixed(3) + '%';
  };

  var moneyFormatter = function (n) {
    var money = n.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    money = money.split('.');
    return money[0];
  };

  var removePercentage = function (field) {

    if (field && field.val()) {
      return parseFloat(field.val().replace('%', ''));
    }

    return null;
  };

  var removeDollarCommas = function (field) {

    if (field && field.val()) {
      return parseInt(field.val().replace(/\$|,/g, ''), 10);
    }

    return null;
  };

  var addDollarCommas = function (nStr) {
    return "$" + addCommas(nStr);
  };

  var addCommas = function (nStr) {
    nStr += '';
    var x = nStr.split('.');
    var x1 = x[0];
    var x2 = x.length > 1 ? '.' + x[1] : '';
    var rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
      x1 = x1.replace(rgx, '$1' + ',' + '$2');
    }
    return x1 + x2;
  };

  var handleReturnAndTabKey = function (keycode, event, callback) {
    if (keycode === ENTER_KEY || keycode === TAB_KEY) {
      $(event.target).trigger("change");
      if (keycode === ENTER_KEY && typeof callback === 'function') {
        callback(event);
      }
      return true;
    }
    return false;
  };

  var isNumber = function (keycode) {
    return keycode >= ZERO_KEY && keycode <= NINE_KEY;
  };

  var isArrow = function (keycode) {
    return keycode === LEFT_KEY || keycode === RIGHT_KEY;
  };

  var isTabOrBackSpace = function (keycode) {
    //"8" is for checking backspace, "9" for tab
    return keycode === BACKSPACE_KEY || keycode === TAB_KEY || keycode === 0;
  };

  var checkDecimalPoint = function (event) {
    // In FF keycode 46 is for delete or decimal point, if event.keyCode it is delete, otherwise decimal point
    // In IE keycode 46 is decimal point, and delete key not get trapped by keypress event
    var isFF = /firefox/i.test(navigator.userAgent);
    if (!isFF) {
      return (event.target.value.split('.').length === 1);
    }
    else {
      if (event.keyCode && (event.keyCode > 0)) {
        return true;
      }
      else {
        return (event.target.value.split('.').length === 1);
      }
    }
  };

  var checkArrow = function (event) {
    if (event.keyCode && (event.keyCode > 0)) {
      return !event.shiftKey;
    }
    return false;
  };

  var formatCurrency = function () {
    var $this = $(this);

    if (event.which === ENTER_KEY) fireChangeEvent(event);
    if (!checkNumeric(event) && !event.which == BACKSPACE_KEY) return;

    var value = $this.val();
    var newValue = "$" + value
      .replace(/\D/g, "")
      .replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    $this.val(newValue).addClass('changed');
    return true;
  };

  var checkNumeric = function(event) {
    return event.which >= ZERO_KEY && event.which <= NINE_KEY;
  };

  // IE/iPad support for formatCurrency on keyup
  var monitorTouchEndForPriceInputs = function () {
    $(document, '.page-content').on('mousedown touchend', function () {
      $('.price-input input').each(fireChangeEvent);
    });
  };

  var fireChangeEvent = function (e) {
    var $this = $(this);

    if (e && $(e.target).is('input')) {
      $this = $(e.target);
    }

    if ($this.hasClass('changed')) {
      $this.trigger('change');
      $this.removeClass('changed');
    }
  };

  var restrictNumbersOnly = function (event, callback) {
    return restrictUserInput(event, callback, true, false, false, false, false, false);
  };

  var restrictNumbersAndDecimalPointOnly = function (event, callback) {
    return restrictUserInput(event, callback, true, false, false, false, false, true);
  };

  var restrictNumbersAndDecimalPointAndNegativeOnly = function (event, callback) {
    return restrictUserInput(event, callback, true, false, false, true, false, true);
  };

  var restrictNumAlphabetOnly = function (event, callback) {
    return restrictUserInput(event, callback, true, true, true, true, true, true);
  };

  var restrictUserInput = function (event, callback, acceptNumber, acceptAlphabet, acceptComma, acceptHyphen, acceptSpace, acceptPoint) {
    var keycode = (event.which ? event.which : event.keyCode);
    if (handleReturnAndTabKey(keycode, event, callback)) {
      return true;
    }

    //left, right arrows
    if (isArrow(keycode)) {
      return checkArrow(event);
    }

    if (acceptNumber) {
      if (isNumber(keycode)) // numbers
      {
        return true;
      }
    }

    if (acceptAlphabet) {
      if (keycode >= 65 && keycode <= 90) {  // a - z
        return true;
      }
      if (keycode >= 97 && keycode <= 122) {  // a - z
        return true;
      }
    }

    if (acceptComma) {
      if (keycode === 44) { //comma
        return true;
      }
    }

    if (acceptHyphen) {
      if (keycode === 45) { // "-"
        return (event.target.selectionStart === 0);
      }
    }

    if (acceptSpace) {
      if (keycode === 32) { //space
        return true;
      }
    }

    if (acceptPoint) {
      if (keycode === DELETE_KEY) {
        return checkDecimalPoint(event);
      }
    }

    return isTabOrBackSpace(keycode);
  };

  var getSearchLocation = function () {
    var lastSearch = '';
    var recentSearches = MOVE.UserActivity.getRecentSearches();
    if (recentSearches && recentSearches.length > 0) {
      var lastSearchQuery = recentSearches[recentSearches.length - 1].query;
      if (lastSearchQuery.postal_code) {
        lastSearch = lastSearchQuery.postal_code;
      }
      else {
        if (lastSearchQuery.city && lastSearchQuery.state_code) {
          lastSearch = lastSearchQuery.city + ',' + lastSearchQuery.state_code;
        }
      }
    }
    return lastSearch;
  };

  var saveLocationToLocalStorage = function(location){
    if (MOVE.UserActivity === undefined || location === undefined || location.indexOf(',') <= 0){
      return;
    }
    var address = location.split(','),
      data = {};
    if (address.length === 3) {
      data['searchType'] = 'postal_code';
      data['zip'] = address[0];
      data['city'] = address[1];
      data['state_code'] = address[2];
    }
    else{
      data['searchType'] = 'city';
      data['zip'] = '';
      data['city'] = address[0];
      data['state_code'] = address[1];
    }

    // Update recent search
    if (data.city !== undefined && data.state_code !== undefined){
      MOVE.UserActivity.updateRecentSearches({
        searchType: "mortgage",
        criteria: {postal: data.zip, city: data.city.trim(), state: data.state_code.trim(), searchType: data.searchType }
      }, false);
    }

  };

  var locationControlAutoCompleteSetup = function(locationBox, successCallback, includeZip) {
    var options = {
      validate_geo: {
        slug_prefix: MOVE.CONSTANTS.RDC_URL_STEMS.MORTGAGE
      },
      autocomplete_suggest: {
        area_types: 'city,postal_code'
      },
      includeZip: includeZip,
      validateSuccessCallback: function (options) {
        saveLocationToLocalStorage(options.location);
        var expiration = MOVE.Helper.setCookieExpiry(60*24*30);
        $.cookie('HF_location', options.slug, { path: '/', expires: expiration });
        if (successCallback) {
          successCallback(options.location, options.zip, options.city, options.state);
        }
      },
      validateSearchCriteriaCallback: function () {
        var searchCriteria = locationBox.val();
        var invalid = searchCriteria.match(/^([0-9]+)\ +([a-z]*)$/ig); // ex '128 parkville' ( for addresses)
        return !invalid;
      },
      placeholderText: "Please Enter a City or Zip Code"
    };

    MOVE.AutoComplete.init(locationBox, null, false, options);
  };

  var trackClick = function (context) {
    $(`[${'data-omtag'}]`, context).click(function (event) {
      var tag = event.currentTarget.getAttribute('data-omtag');
      if (!tag) return;
      RdcTracking.trackEvent('click', { linkName: tag });
    });
  };

  MOVE.MORTGAGE =
  {
    addCommas: addCommas,
    getUrlVars: getUrlVars,
    getQueryValue: getQueryValue,
    validateRange: validateRange,
    addDollarCommas: addDollarCommas,
    removeDollarCommas: removeDollarCommas,
    formatCurrency: formatCurrency,
    monitorTouchEndForPriceInputs: monitorTouchEndForPriceInputs,
    fireChangeEvent: fireChangeEvent,
    removePercentage: removePercentage,
    moneyFormatter: moneyFormatter,
    rateFormatter: rateFormatter,
    getSearchLocation: getSearchLocation,
    saveLocationToLocalStorage: saveLocationToLocalStorage,
    locationControlAutoCompleteSetup: locationControlAutoCompleteSetup,
    restrictNumbersOnly: restrictNumbersOnly,
    restrictNumbersAndDecimalPointOnly: restrictNumbersAndDecimalPointOnly,
    restrictNumbersAndDecimalPointAndNegativeOnly: restrictNumbersAndDecimalPointAndNegativeOnly,
    restrictNumAlphabetOnly: restrictNumAlphabetOnly,
    getDevicePrefix: getDevicePrefix,
    trackClick: trackClick
  };

  return MOVE.MORTGAGE;
})(MOVE || {});



// WEBPACK FOOTER //
// ./mortgage/mortgage.js